/* Global dependencies from Bower */
// TODO: Some of these should be removed, updated, or moved to local import
// Also bundle size optimization by lazy loading

window._ = require("underscore");
window.iostap = require("iostap/build/iostap.min.js");
require("domtokenlist-shim");
window.Backbone = require("backbone");
window.written = require("written");
window.Big = require("big.js");
window.marked = require("marked");
window.PhotoSwipe = require("photoswipe");
window.PhotoSwipeUI_Default = require("photoswipe/dist/photoswipe-ui-default");
window.sha1 = require("sha-1");
require("./fulltilt"); // required by gyronorm https://github.com/dorukeker/gyronorm.js/issues/46
window.GyroNorm = require("gyronorm");
window.moment = require("moment");

/* Local vendors */
window.IScroll = require("./iscroll");
window.eventjs = require("./mudcube.event");
window.Polyglot = require("./polyglot.2.1.3.browserified");
require("./remove-markdown");
window.qq = require("./s3.fine-uploader.core.min");
window.typogr = require("./typogr");
require("./underscore.mixins");
require("./underscore.numbers");
window.wordfind = require("./wordfind").wordfind;
